export default {
  'zh-Hant': { label: '繁體中文', withoutSpaces: true },
  'zh-Hans': { label: '简体中文', withoutSpaces: true },
  'en-US': { label: 'English' },
  'es-ES': { label: 'Español' },
  'ar-SA': { label: 'العربية', rtl: true },
  'ru-RU': { label: 'Русский', font: 'Comfortaa' },
  'pt-BR': { label: 'Português brasileiro' },
  'pt-PT': { label: 'Português' },
  'fr-FR': { label: 'Français' },
  'de-DE': { label: 'Deutsch' },
  'it-IT': { label: 'Italiano' },
  'pl-PL': { label: 'Polski' },
  'tr-TR': { label: 'Türk' },
  'el-GR': { label: 'Ελληνικά' },
  'ko-KR': { label: '한국어' },
  'vi-VN': { label: 'Tiếng việt nam' },
  'ja-JP': { label: '日本語', withoutSpaces: true },
  'he-IL': { label: 'עברית', rtl: true },
  'th-TH': { label: 'ไทย', withoutSpaces: true },
  'cs-CZ': { label: 'Česky' },
  'bg-BG': { label: 'Български' },
  'fi-FI': { label: 'Suomalainen' },
  'sv-SE': { label: 'Svenska' },
  'da-DK': { label: 'Dansk' },
};
